import React from "react";
import LottieOrigin from "react-lottie";

import chartFile from "../../assets/lotties/lf30_editor_iwcvtddu.json";
import { LottieProps } from "../../utils/types/components";

export const Lottie = ({
  animationData,
  options = {},
  height,
  width,
  style,
}: LottieProps): React.ReactElement => (
  <LottieOrigin
    options={{ animationData, loop: true, autoplay: true, ...options }}
    height={height}
    width={width}
    style={style}
  />
);

export const ModalScreenLoadingLottie = (): React.ReactElement => (
  <Lottie animationData={chartFile} height={200} width={200} />
);
